module.exports = __webpack_public_path__ + "static/media/fiocco.9593fc8a.png";